import React from 'react';

import {
  IconButton,
  Card,
  CardHeader,
  Stack,
  ToggleButton,
  CloseIcon,
} from '@gogame/components';
import { FormField } from '@gogame/form';

import { ENGAGEMENT_EVENTS } from 'scenes/CustomAudiences/Audiences/components/AudienceForm/constants';
import { loadEngagements } from 'scenes/CustomAudiences/Audiences/sources/fields';

import { EVENT, VALUE } from './constants';

const Engagement = ({ index, onRemove, disabled }) => {
  const handleRemove = (e) => {
    onRemove(e);
  };
  return (
    <Card elevation={6}>
      <CardHeader
        action={
          <IconButton
            icon={<CloseIcon />}
            tooltip={'Remove'}
            onClick={handleRemove}
          />
        }
      >
        <Stack spacing={2} direction={'row'}>
          <div style={{ width: 256 }}>
            <FormField.Select
              label={'Event'}
              name={`${ENGAGEMENT_EVENTS}[${index}].${EVENT}`}
              source={loadEngagements}
              padding={0}
              disabled={disabled}
            />
          </div>
          <div style={{ width: 88 }}>
            <FormField.ToggleButtonGroup
              name={`${ENGAGEMENT_EVENTS}[${index}].${VALUE}`}
              padding={0}
              disabled={disabled}
            >
              <ToggleButton value={true}>Yes</ToggleButton>
              <ToggleButton value={false}>&nbsp;No&nbsp;</ToggleButton>
            </FormField.ToggleButtonGroup>
          </div>
        </Stack>
      </CardHeader>
    </Card>
  );
};

export default Engagement;
